import { takeLatest, put, call } from 'redux-saga/effects';
import { getArrayApiErrors } from 'utils/get-array-api-errors';
import { sidebarActions } from 'features/sidebar/redux/sidebar.action';
import { getSidebarItemsAPI } from 'features/sidebar/api';
import { AxiosResponse } from 'axios';

function* getSidebarItems(): Generator<any, void, AxiosResponse> {
  try {
    const response = yield call(getSidebarItemsAPI);
    yield put(sidebarActions.getSidebarMenuItemsSuccess(response.data));
  } catch (error) {
    yield put(
      sidebarActions.getSidebarMenuItemsFailure(getArrayApiErrors(error))
    );
  }
}

function* sidebarSaga() {
  yield takeLatest(sidebarActions.getSidebarMenuItemsRequest, getSidebarItems);
}

export default sidebarSaga;
